"use client";
import React from "react";
import { StaticImageData } from "next/image";
import IndustryBenefitGridCard from "./IndustryBenefitGridCard";
import IndustryBenifitsHeaderSection from "./IndustryBenifitsHeaderSection";

export type BenefitItem = {
  icon?: StaticImageData | string | undefined;
  title: string[] | string;
  description: string;
};

export type HeaderConfig = {
  title: React.ReactNode;
  subtitle: string;
  description: string;
  buttonText?: string;
  mode?: "dark" | "light" | string;
  layoutVariant?: 1 | 2;
};

export type IndustryBenifitsGridProps = {
  id?: string;
  header: HeaderConfig;
  benefits: BenefitItem[];
  ctaButton?: React.ReactNode;
};

export default function IndustryBenifitsGrid({
  id = "industry-benifits-grid",
  header,
  benefits,
  ctaButton,
}: IndustryBenifitsGridProps) {
  return (
    <section
      id={id}
      className="w-full max-w-[100vw] relative overflow-hidden bg-[#000000] py-[80px] lg:py-[120px]"
    >
      <div className="max-w-[2500px] mx-auto w-[calc(100%_-_10%)]">
        {/* Header spanning full width, title & subtitle stacked vertically */}
        <IndustryBenifitsHeaderSection header={header} ctaButton={ctaButton} />

        {/* 4 Cards per line grid layout (4 on row 1, 4 on row 2) */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-16 mt-16 lg:mt-24">
          {benefits.map((item, index) => (
            <IndustryBenefitGridCard key={index} item={item} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
}
